/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
/**
 * This is here because DART requires it. It is noop in JS.
 */
function wtfInit() { }
exports.wtfInit = wtfInit;
//# sourceMappingURL=wtf_init.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/@angular/core/src/profile/wtf_init.js
 ** module id = 375
 ** module chunks = 0
 **/